import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ModalConfirmationHeader,
  ModalConfirmationContent,
  ModalConfirmationFooter,
  ModalActions,
} from '../../../../components/modal';
import { PrimaryButton } from '../../../../components/button';

type Props = {
  closeModal: () => void;
};

export const ResetPasswordValidated: FC<Props> = ({ closeModal }) => (
  <>
    <ModalConfirmationHeader
      title={
        <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordValidated.tsx/4" />
      }
      onClose={closeModal}
    />
    <ModalConfirmationContent>
      <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordValidated.tsx/1" />
      <br />
      <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordValidated.tsx/2" />
    </ModalConfirmationContent>
    <ModalConfirmationFooter>
      <ModalActions>
        <PrimaryButton onClick={closeModal}>
          <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordValidated.tsx/3" />
        </PrimaryButton>
      </ModalActions>
    </ModalConfirmationFooter>
  </>
);
